(() => {
  'use strict';
  const documentRoot = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const selectors = [
    '.v13-hero__narrative',
    '.v13-gallery__editorial',
    '.v9-chamber__story',
    '.v4-prologue__head',
    '.v4-prologue__body',
    '.v4-atlas__heading',
    '.v4-founder__copy',
    '.v4-concierge__lead',
    '.v4-concierge__content',
    '.v5-principles__center',
    '.v5-principles__grid > div',
    '.v10-house-letters__intro',
    '.v10-house-letters__form',
    '.v13-pdp-story__words',
    '.bh-pdp__stage',
    '.bh-pdp__info-inner',
    '.v10-pdp-letter__process',
    '.bh-story__chapter',
    '.bh-faq__intro',
    '.bh-faq__list',
    '.bhx-contact__story',
    '.bhx-contact__card',
    '.bhx-contact__lower',
    '.bhx-selection__opening',
    '.bhx-selection__piece',
    '.bhx-selection__aside',
    '.v10-cart-afterword__lead',
    '.v10-cart-afterword__facts > div',
    '.v10-delivery__intro',
    '.v10-delivery__chapters',
    '.v10-delivery__foot',
    '.bt-page__intro',
    '.bt-page__body',
    '.bt-article__head',
    '.bt-article__content',
    '.bt-blog__card',
    '.bt-search__results',
    '.bh-footer__mission',
    '.bh-footer__columns'
  ];

  let observer;
  const ensureObserver = () => {
    if (observer || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('bt5-inview');
        observer.unobserve(entry.target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  };

  const initializeReveals = (scope = document) => {
    if (reduce.matches) return;
    ensureObserver();
    const targets = scope.querySelectorAll(selectors.join(','));
    let stage = 0;
    for (const element of targets) {
      if (element.dataset.bt5RevealReady === 'true') continue;
      if (element.closest('.v5-catalogue, .v5-nav, .v8-opening, .v5-lightbox, [data-v10-reveal], [data-v8-editorial]')) continue;
      if (element.hasAttribute('data-reveal') || element.hasAttribute('data-v5-reveal')) continue;
      element.dataset.bt5RevealReady = 'true';
      element.dataset.bt5Reveal = '';
      element.style.setProperty('--bt5-stagger', `${(stage % 4) * 65}ms`);
      stage += 1;
      const rect = element.getBoundingClientRect();
      if (rect.height === 0 || rect.top < window.innerHeight * 0.82 || !observer) {
        element.classList.add('bt5-inview');
      } else {
        observer.observe(element);
      }
    }
  };

  const bindProductImages = () => {
    document.addEventListener('click', event => {
      const thumbnail = event.target.closest('[data-thumb]');
      if (!thumbnail) return;
      const root = thumbnail.closest('[data-product-root]');
      const media = root?.querySelector('.bh-pdp__photo');
      if (!media || reduce.matches) return;
      media.classList.remove('bt5-photo-switching');
      void media.offsetWidth;
      media.classList.add('bt5-photo-switching');
      window.setTimeout(() => media.classList.remove('bt5-photo-switching'), 440);
    }, true);
  };

  const bindPointerLight = (scope = document) => {
    if (!fine.matches || reduce.matches) return;
    const surface = scope.querySelector('.v5-nav__image');
    if (!surface || surface.dataset.bt5PointerReady) return;
    surface.dataset.bt5PointerReady = 'true';
    let frame = null;
    let x = 50;
    let y = 50;
    const update = () => {
      frame = null;
      surface.style.setProperty('--bt5-light-x', `${x.toFixed(1)}%`);
      surface.style.setProperty('--bt5-light-y', `${y.toFixed(1)}%`);
    };
    surface.addEventListener('pointermove', e => {
      const box = surface.getBoundingClientRect();
      if (box.width <= 0 || box.height <= 0) return;
      x = Math.max(0, Math.min(100, ((e.clientX - box.left) / box.width) * 100));
      y = Math.max(0, Math.min(100, ((e.clientY - box.top) / box.height) * 100));
      if (frame === null) frame = requestAnimationFrame(update);
    }, { passive: true });
    surface.addEventListener('pointerleave', () => {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      surface.style.removeProperty('--bt5-light-x');
      surface.style.removeProperty('--bt5-light-y');
    }, { passive: true });
  };

  const apply = scope => {
    if (!reduce.matches) documentRoot.classList.add('bt5-effects-ready');
    initializeReveals(scope);
    bindPointerLight(scope);
  };

  const start = () => {
    bindProductImages();
    apply(document);
    document.addEventListener('shopify:section:load', e => apply(e.target));
    reduce.addEventListener('change', () => {
      documentRoot.classList.toggle('bt5-effects-ready', !reduce.matches);
      if (!reduce.matches) initializeReveals(document);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
